import { useCallback, useState } from 'react';
import { buildMentionsPayload, buildMessageWithTokens, filterStaleMentions, TrackedMention } from './mentionText.utils';

export interface MentionableUser {
    id: number;
    displayName: string;
    userRole: string | null;
}

export const useMentionState = () => {
    const [trackedMentions, setTrackedMentions] = useState<TrackedMention[]>([]);

    const addMention = useCallback((user: MentionableUser, isSubscriber: boolean) => {
        const mention: TrackedMention = {
            id: user.id,
            displayName: user.displayName,
            userRole: user.userRole,
            isSubscriber
        };
        setTrackedMentions((prev) => (prev.some((m) => m.id === user.id) ? prev : [...prev, mention]));
    }, []);

    const removeStaleMentions = useCallback((currentText: string) => {
        setTrackedMentions((prev) => filterStaleMentions(currentText, prev));
    }, []);

    const buildSubmitPayload = useCallback(
        (text: string) => ({
            message: buildMessageWithTokens(text, trackedMentions),
            mentions: buildMentionsPayload(trackedMentions)
        }),
        [trackedMentions]
    );

    const reset = useCallback(() => setTrackedMentions([]), []);

    return { trackedMentions, addMention, removeStaleMentions, buildSubmitPayload, reset };
};
